import {AfterContentChecked, AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {Observable} from 'rxjs/Observable';
import {Assignment} from '../assignment/assignment.model';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Contact} from '../contact/contact.model';
import {RoutePrefix} from '../shared/route-prefix';
import {CrudConfig, DatatableViewComponent} from '@ngx-ivengi/crud';
import {Channel} from './channel.model';
import {ChannelService} from './channel.service';
import {ChannelDuplicateModalComponent} from './channel-duplicate-modal.component';
import {EnumerationService} from '../enumeration/enumeration.service';

@Component({
  selector: 'app-channel-datatable',
  templateUrl: './channel-datatable.component.html'
})
export class ChannelDatatableComponent extends DatatableViewComponent<Channel> implements OnInit, OnDestroy, AfterContentChecked {
  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public viewMode: boolean = false;
  @Input() public linkView: boolean = false;
  @Input() public assignment: Assignment;
  @Input() public filters: Observable<{[key: string]: any}>;

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @ViewChild(ChannelDuplicateModalComponent)
  public channelDuplicateModal: ChannelDuplicateModalComponent;

  public assignmentType: string;
  public editRoute: string;
  public pageLimitOptions: string[];
  public skipToPage: number = null;

  constructor(
    private router: UIRouter,
    private channelService: ChannelService,
    private crudConfig: CrudConfig,
    private enumService: EnumerationService,
  ) {
    super(channelService);
  }

  public ngOnInit(): void {
    const stateParts = this.router.stateService.$current.name.split('.');
    this.assignmentType = stateParts[1] || '';
    this.editRoute      = `assignment.${this.assignmentType}.edit.channel.edit`;

    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.channelService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    if(this.filters && this.filters instanceof Observable) {
      this.filters.subscribe((filters) => {
        this.requestParams.filters.removeParams();
        for(const key in filters) {
          if(filters.hasOwnProperty(key)) {
            this.requestParams.filters.addParam({
              id: this.crudConfig.getFilterId(),
              operator: 'eq',
              value: filters[key],
              key
            });
          }
        }

        this.filter(null);
      });
    }
    this.enumService.get('page-limit-options').subscribe((pageLimitOptions) => {
      this.pageLimitOptions = pageLimitOptions.map(limit => limit.split('PL')[1]);
    });
  }

  public onPageSizeChanged(event) {
    this.requestParams.pagination.limit = event;
    this.requestParams.pagination.offset = 0;
    this.fetchData();
  }

  public ngAfterContentChecked(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.channelService.setRoutePrefix(prefix.join('/').toLowerCase());
    }
  }

  public ngOnDestroy(): void {
    this.channelService.clearRoutePrefix();
  }

  public terminateItem(item) {
    this.confirmationModal.show({
      channelId: [item.id]
    });
  }

  public onTerminateConfirmation(event) {
    if(event.confirmed === true) {
      this.channelService.terminate(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public duplicateItem(item) {
    this.channelDuplicateModal.show({
      sourceChannelId: [item.id],
      bIncludeThroughputs: null
    });
  }

  public onDuplicateConfirmation(event) {
    if(event.confirmed === true) {
      this.channelService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
      this.channelService.duplicate(event.data).subscribe((channel: Channel) => {
        const params = Object.assign({}, this.router.stateService.params, {channelId: channel[0].id});
        this.router.stateService.go(this.router.stateService.$current.name, params, {reload: true});
      });
    }
  }

  public getPageNumbers(rows: number, pageSize: number) {
    return Array(Math.ceil(rows / pageSize));
  }

  public onCurrentPageChange($event: any) {
    const pageNumber = parseInt($event.target.value, 10);
    if (!isNaN(pageNumber)) {
      this.requestParams.pagination.offset = (pageNumber - 1);
      this.fetchData();
    }
  }

  onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go(this.editRoute, { channelId: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-datatable.component.ts